<template>
	<div class="navbar-container" :class="isHome?'home-nav':''">
		<nav class="bg-white shadow-sm" >
			<div class="max-width mx-auto">
				<div class="flex justify-between items-center h-20">
					<div class="flex items-center">
						<img src="@/assets/img/logo.png" alt="迪瓜租机" class="logo-img" />
						<!-- <span class="ml-2 text-xl font-medium text-gray-900">迪瓜租机</span> -->
					</div>
					<div class="flex space-x-8">
						<a
							v-for="item in navList"
							:key="item.path"
							@click="linkHandle(item.path)"
							class="text-gray-700 hover:text-green-600 text-lg"
							:class="$route.fullPath == item.path ? 'is-active' : ''"
							>{{ item.title }}</a
						>
					</div>
					<div class="flex justify-center items-center bg-gray-50" v-show="searchInputShow">
						<div class="w-[600px]">
							<div class="relative flex items-center" style="width: 350px">
								<input
									type="text"
									v-model="searchText"
									placeholder="请输入关键词搜索"
									class="w-full h-10 pl-4 pr-12 text-base text-gray-700 placeholder-gray-400 bg-white border rounded-lg focus:outline-none input-box"
								/>
								<button
									@click="handleSearch"
									class="absolute right-1 top-1 h-full px-4 text-base text-white transition-colors duration-200 !rounded-button whitespace-nowrap search-color-btn"
								>
									<i class="fas fa-search mr-1"></i>
									搜索
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</nav>
	</div>
</template>

<script>
export default {
	props: {
		searchInputShow: {
			type: Boolean,
			default: false,
		},
		list: {
			type: Array,
			default: function () {
				return [];
			},
		},
	},
	watch:{
			// 监听路由变化
			'$route.path': {
			immediate: true, // 初始化时立即执行
			handler(newPath) {
				this.isHome = newPath === '/' || newPath === '/home';
				this.updateNavBackground();
			},
		},
	},
	data() {
		return {
			searchText: '',
			curPath: '/home',
			navList: [
				{
					title: '首页',
					path: '/home',
				},
				{
					title: '个人租',
					path: '/individualRent',
				},
				{
					title: '迪瓜资讯',
					path: '/information',
				},
				{
					title: '赋能保障',
					path: '/SettledDigua',
				},
				{
					title: '关于迪瓜',
					path: '/about',
				},
				{
					title: '联系我们',
					path: '/Contact',
				},
			],
			isScrolled: false, // 是否已滚动
			isHome:'',
		};
	},
	mounted() {
		// 初始化时检查当前路由
		this.isHome = this.$route.path === '/' || this.$route.path === '/home';
		this.updateNavBackground();
		// 监听滚动事件
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		// 移除滚动事件监听
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		// 更新导航栏背景
		updateNavBackground() {
			const navElement = document.querySelector('nav');
			if (navElement) {
				navElement.style.background = this.isHome && !this.isScrolled ? 'transparent' : 'white';
				navElement.style.boxShadow = this.isScrolled ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'none';
			}
		},
		// 处理滚动事件
		handleScroll() {
			const scrollTop = window.scrollY || document.documentElement.scrollTop;
			this.isScrolled = scrollTop > 0; // 如果滚动距离大于 0，则标记为已滚动
			this.updateNavBackground();
		},
		handleSearch() {
			if (!this.searchText.trim()) {
				return;
			}
			console.log('搜索内容:', this.searchText);
		},
		linkHandle(item) {
			this.curPath = this.$route.fullPath;
			console.log(this.curPath, item);
			if (this.curPath.includes(item)) return;
			this.$router.push(item);
		},
	},
};
</script>

<style lang="scss" scoped>
input::-webkit-input-placeholder {
	font-size: 14px;
}
input::-moz-placeholder {
	font-size: 14px;
}
input:-ms-input-placeholder {
	font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
.navbar-container {
	.navbar {
		display: flex;
		align-items: center;
		height: 72px;
		&__left,
		&__right {
			flex: 0 0 20%;
		}
		&__left {
			text-align: right;
			img {
				width: 50px;
				height: 50px;
			}
		}
		&__middle {
			flex: 1;
			ul {
				display: flex;
				justify-content: flex-end;
				li {
					min-width: 100px;
					cursor: pointer;
					a {
						&:hover {
							color: #6b7cff;
						}
					}
				}
			}
		}
	}
}
.search-color-btn {
	background: #00733d;
	// margin-top: 1px;
	// margin-bottom: 1px;
	&:hover {
		background: #008347;
	}
	&:active {
		background: #009351;
	}
}
.h-full {
	height: 82%;
}
.input-box {
	border-color: #00733d;
}
.logo-img {
	width: 153px;
	height: 40px;
}
// 添加固定导航栏样式
nav {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 80px;
	z-index: 1000; // 确保导航栏在最上层
	transition: background 0.3s ease, box-shadow 0.3s ease; // 添加过渡效果
}
.navbar-container {
	padding-top: 80px;
}
.navbar-lin {
	padding: 0 260px;
}
.is-active {
	color: #00733d !important;
	border-bottom: #00733d 2px solid;
	padding-bottom: 5px;
}
.home-nav{
	position: fixed;
	z-index: 999;
}
</style>
